import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  open: boolean;
  name: string;
  onAddNew: () => void;
  onClose: () => void;
};

export default function SuccessModal({ open, name, onAddNew, onClose }: Props) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = original;
    };
  }, [open]);

  if (!open || !isClient) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40 p-4">
      <div className="w-full max-w-[420px] p-4 sm:p-6 rounded-lg bg-white shadow-lg">
        <p className="text-base sm:text-lg text-gray-700 mb-6 sm:mb-10 text-left">
          You have successfully added {name || 'the artisan'} as an Artisan.
        </p>

        <div className="flex flex-col-reverse sm:flex-row items-center justify-end gap-4 sm:gap-6">
          <button onClick={onAddNew} className="w-full sm:w-auto text-sm sm:text-lg text-[#2C7DA0] hover:text-[#1f5f99] transition-colors">
            Add new Artisan
          </button>

          <button onClick={onClose} className="w-full sm:w-auto text-sm sm:text-lg text-gray-700 hover:text-gray-900 transition-colors">
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}